import { connect } from 'react-redux'
import { setConfigurator } from '../../actions'
import ContractsListItem from './ContractsListItem'

const mapStateToProps = state => ({
  configurator: state.configurator
})

const mapDispatchToProps = {
  setConfigurator
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractsListItem)
